import { clearBytes, decodeBytes, unwrapDeviceSecretForHello } from '@safewallet/core';
import type { DeviceState } from './device-store';
import { getHelloSecret } from './hello';

/**
 * The device secret, from wherever it lives.
 *
 * Once fingerprint unlock is on, the plaintext copy is deleted and the secret exists only
 * in the wrapped form, so this asks the device for the hardware key and unwraps it. That
 * is what makes a stolen copy of local storage useless: without the device's own key
 * there is nothing to guess the PIN against.
 */
export async function loadDeviceSecret(device: DeviceState): Promise<Uint8Array> {
  if (device.deviceSecret) return decodeBytes(device.deviceSecret);
  if (!device.helloCredentialId || !device.helloPrfSalt || !device.wrappedDeviceSecret) {
    throw new Error('This wallet is missing its device key on this browser.');
  }
  const hardwareSecret = await getHelloSecret(device.helloCredentialId, device.helloPrfSalt);
  try {
    return await unwrapDeviceSecretForHello(device.wrappedDeviceSecret, hardwareSecret);
  } finally {
    await clearBytes(hardwareSecret);
  }
}
